module.exports = __webpack_public_path__ + "static/media/opensans-regular-webfont.89331c7e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/opensans-regular-webfont.woff
// module id = 1014
// module chunks = 0